import SiteFooter from './SiteFooter';
import SiteHeader from './SiteHeader';
import './PrivacyPage.css';

function PrivacyPage() {
  return (
    <main className="page-shell privacy-page">
      <SiteHeader />
      <section className="privacy-hero">
        <span className="eyebrow">Privacy</span>
        <h1>Privacy Policy</h1>
        <p>Last updated: 14.07.2026</p>
      </section>

      <section className="privacy-content" aria-label="Privacy policy">
        <article className="privacy-intro">
          <p>
            Crumbs is a private app for sharing small weekly updates with the people you
            choose. Your privacy matters to us, and we want to be clear about what we
            collect, why we collect it, and how you can control your data.
          </p>
        </article>

        <PolicySection title="1. Information we collect">
          <p>When you use Crumbs, we may collect the following information:</p>

          <h3>Account information</h3>
          <p>
            When you create an account, we may collect your name, email address, profile
            photo, and sign-in information.
          </p>

          <h3>Content you add to Crumbs</h3>
          <p>
            Crumbs lets you add and share small updates from your week, such as photos,
            captions, notes, comments, reactions, and other content you choose to upload.
          </p>

          <h3>Circles and invites</h3>
          <p>
            We collect information about the circles you create or join, the people you
            invite, and the circles you choose to share your weekly crumbs with.
          </p>

          <h3>Usage and analytics data</h3>
          <p>
            We may collect basic analytics data to understand how the app is used and
            improve the experience. This may include actions such as opening the app,
            creating a circle, adding crumbs, sharing a week, viewing a circle, or using
            features inside the app.
          </p>

          <h3>Device and technical information</h3>
          <p>
            We may collect basic technical data such as device type, app version,
            operating system, crash logs, and performance information.
          </p>
        </PolicySection>

        <PolicySection title="2. How we use your information">
          <p>We use your information to:</p>
          <ul>
            <li>create and manage your account;</li>
            <li>let you create circles and invite people;</li>
            <li>let you upload, share, view, comment on, and react to crumbs;</li>
            <li>keep your content private to the people you choose;</li>
            <li>improve, debug, and maintain the app;</li>
            <li>understand how people use Crumbs;</li>
            <li>keep the app safe and secure.</li>
          </ul>
          <p>We do not sell your personal information.</p>
        </PolicySection>

        <PolicySection title="3. Who can see your content">
          <p>Your crumbs are shared only with the circles or people you choose.</p>
          <p>
            People in a circle may be able to see the crumbs, comments, reactions, and
            profile information you share inside that circle.
          </p>
          <p>
            Crumbs is not a public feed. Your content is not intended to be publicly
            visible unless you choose to share it outside the app yourself.
          </p>
        </PolicySection>

        <PolicySection title="4. Third-party services">
          <p>
            Crumbs may use third-party services to help us run the app, such as
            authentication, hosting, storage, analytics, crash reporting, or app
            infrastructure.
          </p>
          <p>
            These services may process limited information on our behalf only for the
            purposes of providing and improving Crumbs.
          </p>
          <p>
            For example, if Crumbs uses Firebase, Google may process data as part of
            Firebase Authentication, Firestore, Storage, Analytics, Crashlytics, or
            Hosting, depending on which services are enabled.
          </p>
        </PolicySection>

        <PolicySection title="5. Data storage and security">
          <p>
            We take reasonable steps to protect your information and keep your content
            secure.
          </p>
          <p>
            However, no online service can be completely secure. You should only upload
            content that you are comfortable sharing with the people in your selected
            circles.
          </p>
        </PolicySection>

        <PolicySection title="6. How long we keep your information">
          <p>
            We keep your information for as long as your account is active or as needed
            to provide Crumbs.
          </p>
          <p>
            If you delete your account or ask us to delete your data, we will delete or
            anonymise your personal information unless we need to keep certain information
            for legal, security, or operational reasons.
          </p>
        </PolicySection>

        <PolicySection title="7. Your choices and rights">
          <p>Depending on where you live, you may have rights to:</p>
          <ul>
            <li>access the personal information we hold about you;</li>
            <li>correct inaccurate information;</li>
            <li>request deletion of your information;</li>
            <li>object to or restrict certain uses of your information;</li>
            <li>withdraw consent where we rely on consent;</li>
            <li>request a copy of your data.</li>
          </ul>
          <p>You can contact us at crmbsapp@gmail.com to make a request.</p>
        </PolicySection>

        <PolicySection title="8. Deleting your account">
          <p>You can request deletion of your account and personal data by contacting us at:</p>
          <p>
            <a href="mailto:crmbsapp@gmail.com">crmbsapp@gmail.com</a>
          </p>
          <p>We may ask you to confirm your identity before deleting your account.</p>
        </PolicySection>

        <PolicySection title="9. Children's privacy">
          <p>
            Crumbs is not intended for children under 13. We do not knowingly collect
            personal information from children under 13.
          </p>
          <p>
            If we learn that we have collected personal information from a child under
            13, we will take steps to delete it.
          </p>
        </PolicySection>

        <PolicySection title="10. Changes to this policy">
          <p>
            We may update this Privacy Policy from time to time. If we make significant
            changes, we will update the date at the top of this page and, where
            appropriate, notify you in the app or by other means.
          </p>
        </PolicySection>

        <PolicySection title="11. Contact us">
          <p>
            If you have any questions about this Privacy Policy or how we handle your
            data, contact us at:
          </p>
          <p>
            <a href="mailto:crmbsapp@gmail.com">crmbsapp@gmail.com</a>
          </p>
        </PolicySection>
      </section>
      <SiteFooter />
    </main>
  );
}

function PolicySection({ title, children }) {
  return (
    <article>
      <h2>{title}</h2>
      {children}
    </article>
  );
}

export default PrivacyPage;
